/**
 * Get uniba footer action
 * @module src/actions/getUnibaFooter
 */
export const GET_UNIBA_FOOTER = 'GET_UNIBA_FOOTER';

/**
 * Get uniba footer.
 * @function getUnibaFooter
 * @returns {Object} Get uniba footer action.
 */
export function getUnibaFooter(params) {
  return {
    type: GET_UNIBA_FOOTER,
    request: {
      op: 'get',
      path: `/@getFooterUniba`,
      params: params,
    },
  };
}
